import jsPDF from "jspdf"
import "jspdf-autotable"
import * as D from "../../utilities/Drawer"
import moment from "moment"

export const batterieCheckPDF = (batteries) => {
	const doc = new jsPDF("p", "mm")
	let my = 20
	let head = [
		"Label",
		"Quantité minimum",
		"Quantité en stock",
		"Quantité à commander",
	]
	let options = {
		startY: my,
		styles: {
			font: "times",
		},
		headStyles: {
			valign: "middle",
			halign: "center",
		},
		bodyStyles: {
			valign: "middle",
			halign: "center",
		},
	}
	D.textBig2(doc, "Contrôle des Batteries", 105, my, "center")
	my += 5
	D.textNormal(
		doc,
		`Etat du ${moment().format("DD-MM-YYYY à HH:mm")}`,
		105,
		my,
		"center",
	)
	my += 10
	for (let [categorie, articles] of Object.entries(batteries)) {
		D.textTitle(doc, categorie, 20, my)
		my += 5
		let _articles = []
		articles.forEach((_article) => {
			_articles.push([
				_article.nom,
				_article.limite,
				_article.quantite,
				_article.should_order
					? _article.limite - _article.quantite
					: "",
			])
		})
		doc.autoTable(head, _articles, { ...options, startY: my })
		my = parseInt(doc.lastAutoTable.finalY) + 10
	}
	doc.save(`controle_batteries_${moment().format("DD-MM-YYYY")}.pdf`)
}
